import { useState, useEffect } from 'react';
import { voicesService } from '../services/voicesService';
import voiceAnalytics from '../utils/voiceAnalytics';

export const useVoices = () => {
  const [voices, setVoices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchVoices = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // Track voice library access
      voiceAnalytics.trackVoiceLibraryAccess('fetch_voices');
      
      const response = await voicesService.getVoices({ page_size: 55 });
      const voicesArray = Array.isArray(response) ? response : response.voices || [];

      // Transform voice objects to ensure consistent id property
      const transformedVoices = voicesArray.map(voice => ({
        ...voice,
        id: voice.id || voice.voice_id,
        name: voice.name || `Voice ${(voice.id || voice.voice_id || '').substring(0, 6)}...`
      }));

      setVoices(transformedVoices);
      
      // Track successful voice library load
      voiceAnalytics.trackVoiceLibraryLoad({
        total_voices: transformedVoices.length,
        voice_types: transformedVoices.reduce((types, voice) => {
          const category = voice.category || 'unknown';
          types[category] = (types[category] || 0) + 1;
          return types;
        }, {})
      });
      
    } catch (err) {
      setError(err.message);
      
      // Track voice library error
      voiceAnalytics.trackVoiceLibraryError('fetch_error', err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchVoices();
  }, []);

  return { voices, isLoading, error, refetch: fetchVoices };
}; 